import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-password-checker',
  templateUrl: './password-checker.component.html',
  styleUrls: ['./password-checker.component.scss'],
})
export class PasswordCheckerComponent implements OnInit {
  @Input() passwordFieldName!: string;

  hasUpperCase: boolean = false;
  hasLowerCase: boolean = false;
  hasNumbers: boolean = false;
  hasNonAlphas: boolean = false;
  hasLength: boolean = false;
  showRed: boolean = false;

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      const passwordField = document.getElementById(this.passwordFieldName) as HTMLInputElement;

      if (passwordField) {
        passwordField.addEventListener('change', (event) => {
          this.showRed = true;
          this.checkPassword((event.target as HTMLInputElement).value);
        });

        passwordField.addEventListener('input', (event) => {
          this.showRed = false;
          this.checkPassword((event.target as HTMLInputElement).value);
        });
      }
    }, 0);
  }

  checkPassword(password: string) {
    this.hasUpperCase = /[A-Z]/.test(password);
    this.hasLowerCase = /[a-z]/.test(password);
    this.hasNumbers = /\d/.test(password);
    this.hasNonAlphas = /\W/.test(password);
    this.hasLength = password.length >= 8;
  }
}
